import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import globalSettingsStores from '../../../../stores/settings-stores';
import { SettingsServicePaymentType } from '../../../../api/types/settings/payments/settings-service-payment-type';
import dateFormat from '../../../../utils/date-format';
import { Dialog } from 'primereact/dialog';
import { DialogAddNewServicePaymentType } from './componenets/dialog-add-new-service-payment-type';
import './services.settings.payment-types.css';
import { observer } from 'mobx-react-lite';
import { EditTextDialog } from '../../../settings/componenets/edit-entity-name-dialog/edit-text-dialog';
import { updateEntityNameOperation } from '../../../settings/operations/update-entity-name/update-entity-name-operation';
import { SettingsEntityType } from '../../../settings/operations/update-entity-name/settings-entity-types';
import { deletePaymentTypeOperation } from './operations/delete-payment-type-operation';

export const ServicesSettingsPaymentTypes = observer(() => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [editPaymentType, setEditPaymentType] =
    useState<SettingsServicePaymentType | null>(null);
  const [deletePaymentTypeId, setDeletePaymentTypeId] = useState<number | null>(
    null,
  );
  const [loading, setLoading] = useState(false);

  const dialogHide = () => {
    setShowDialog(false);
  };

  const dialogDisplay = () => {
    setShowDialog(true);
  };

  const handleEditPaymentType = (paymentType: SettingsServicePaymentType) => {
    setEditPaymentType(paymentType);
  };

  const handleSavePaymentType = async (id: number, newName: string) => {
    await updateEntityNameOperation(
      SettingsEntityType.PAYMENT_TYPE,
      id,
      newName,
      setLoading,
    );
  };

  const handleDeletePaymentType = async (paymentTypeId: number) => {
    await deletePaymentTypeOperation(paymentTypeId, setDeletePaymentTypeId);
  };

  return (
    <div>
      <Button
        style={{ height: '30px' }}
        label={'הוספה'}
        onClick={dialogDisplay}
      />
      <div style={{ height: '8px' }} />
      <DataTable
        value={globalSettingsStores.servicePaymentTypes}
        loading={isLoading}
        rows={10}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        className="p-datatable-striped"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="paymentServiceTypeName"
          header="סוג השרות"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="תאריך יצירה"
          sortable
          body={(rowData: SettingsServicePaymentType) =>
            dateFormat.displayFormatDate(new Date(rowData.createdAt))
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: SettingsServicePaymentType) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-pencil"
                text
                severity="warning"
                tooltip={'עריכת סוג תשלום'}
                onClick={() => handleEditPaymentType(data)}
              />
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת סוג תשלום'}
                loading={deletePaymentTypeId === data.id}
                disabled={deletePaymentTypeId !== null}
                onClick={() => handleDeletePaymentType(data.id)}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        header="הוספת סוג שרות"
        visible={showDialog}
        onHide={dialogHide}
        style={{
          width: '500px',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
      >
        <DialogAddNewServicePaymentType closeDialog={dialogHide} />
      </Dialog>

      <EditTextDialog
        id={editPaymentType?.id}
        value={editPaymentType?.paymentServiceTypeName}
        title="עריכת סוג תשלום"
        label="שם סוג התשלום"
        loading={loading}
        onSave={handleSavePaymentType}
        onHide={() => setEditPaymentType(null)}
      />
    </div>
  );
});
